import { Footer, Card, CardContent } from '@bpinternal/ui-kit-next'
import { AlertTriangle, ExternalLink } from 'lucide-react'
import { getCdmStudioUrl } from '~/shared/configurations'

type Props = {
  botId: string
  close: () => void
  onSubmit: () => void
}

export const PublishWarningDialog = ({ botId, close, onSubmit }: Props) => {
  return (
    <div className="flex flex-col gap-2">
      <p>This action will publish your bot.</p>
      <Card className="border-amber-200 bg-amber-50">
        <CardContent className="p-4">
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 flex-shrink-0 text-amber-700" />
            <p className="text-amber-700">Any current changes in the Studio will be published.</p>
            <a
              href={getCdmStudioUrl(botId)}
              className="flex items-center gap-1 text-sm text-brand-700 underline hover:text-brand-600"
              target="_blank"
              rel="noopener noreferrer"
            >
              Open Studio
              <ExternalLink className="h-3 w-3" />
            </a>
          </div>
        </CardContent>
      </Card>
      <Footer
        confirmLabel="Confirm"
        onConfirm={() => {
          onSubmit()
          close()
        }}
        showCancel={true}
        cancelLabel="Cancel"
        onCancel={close}
      />
    </div>
  )
}
